export function errorToastKey(type: unknown, content: unknown): string | undefined {
  if ((type !== 'error' && type !== 'warning') || typeof content !== 'string' || !content.trim()) return undefined;
  return `qm-${type}:${content.trim()}`;
}
